<section>
  <div class="game-notes">
    <div class="game-notes-head p-2">
      <h3 class="game-notes-title mb-0 fs-5">Game Notes</h3>
      <mat-icon mat-dialog-close class="cursor-pointer">close</mat-icon>
    </div>
    <div class="game-notes-wrapper" #scrollContainer>
      @for (item of gameNotes; track item) {
        <div class="game-notes-container p-2">
          <div class="user-info d-flex">
          <app-image-placeholder [imageData]="{  image:item?.user?.image,
                title:item?.user?.username,
                radius:'40px',
                class:'mr-1'}
        "/>
              <div class="name-date flex-grow-1">
                <h3 class="mb-0 username">{{ item?.user?.username }}</h3>
                <span class="note-date">{{ item.createDate | date: 'dd MMM yyyy h:mm:ss a' }}</span>
              </div>
              <mat-icon color="primary" class="cursor-pointer" (click)="deleteNote(item)">delete</mat-icon>
            </div>
            <span class="fw-400 game-note">{{ item?.note }}</span>
          </div>
        }
      </div>
    </div>
    <div class="game-notes-add mt-1" [formGroup]="noteForm">
      <mat-form-field
        appearance="fill"
        class="col-12 game-notes-field">
        <input
          matInput
          type="text"
          placeholder="Leave a Note"
          formControlName="note"
          (keydown.enter)="onSave()"
          />
          <mat-icon matIconSuffix color="primary" class="cursor-pointer" (click)="onSave()">
            send
          </mat-icon>
        </mat-form-field>
      </div>
    </section>
